import rbac from '../../../backend/rbac/rbacService.js';

// Espelha a capacidade 'read' de cameraSourceRbac.can() (nega apenas press) —
// isso e SOMENTE uma checagem de UX no frontend para a rota detached (evitar
// mostrar uma pagina vazia/quebrada para quem sera 403 em toda chamada). A
// autoridade real e sempre imposta pelo backend em cada rota de
// camera-sources (ver src/backend/cameraSources/cameraSourceRbac.js) — nao
// existe aqui uma segunda hierarquia de papeis (missao Fase 1B, secao 20).
export function canAccessCameraConsole(user) {
  if (!user) return false;
  return !rbac.hasAnyRole(user, ['press']);
}

export default { canAccessCameraConsole };
